import React, {useState} from 'react'
import { useLocation, Link } from "react-router-dom";
import {
    Navbar,
    Typography,
    Button,
    IconButton,
    Breadcrumbs,
    Input,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Avatar,
} from "@material-tailwind/react";
import {
    UserCircleIcon,
    Cog6ToothIcon,
    BellIcon,
    ClockIcon,
    CreditCardIcon,
    Bars3Icon,
    MagnifyingGlassIcon,
    PowerIcon
} from "@heroicons/react/24/solid";

export function NavBar({ routes, /*setOpenSidenav, openSidenav,*/ userName}) {

    const handleLogout = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(routes.logout_url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                },
            });

            if (response.ok) {
                window.location.href = '/';
            } else {
                console.error('Logout failed');
            }
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    const toggleSidenav = () => {
        const sidenavElement = document.getElementById("sideNavbar");
        const isOpen = sidenavElement.classList.contains("translate-x-0");

        sidenavElement.classList.remove("translate-x-0", "-translate-x-80");
        sidenavElement.classList.add(isOpen ? "-translate-x-80" : "translate-x-0");
    };

    return (
        <Navbar
            color={"white"}
            className={`rounded-xl transition-all px-0 py-1 shadow-none`}
            fullWidth
            blurred={false}
        >
            <div className="flex flex-col-reverse justify-between gap-6 md:flex-row md:items-center">
                <div className="capitalize">
                    <Breadcrumbs
                        className={`bg-transparent p-0 transition-all ${
                            false ? "mt-1" : ""
                        }`}
                    >
                        <a href={`#`} className="flex">
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal opacity-50 transition-all hover:text-blue-500 hover:opacity-100"
                            >
                                {routes.main.toUpperCase()}
                            </Typography>
                        </a>
                        <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal"
                        >
                            {routes.current.toUpperCase()}
                        </Typography>
                    </Breadcrumbs>
                    <Typography variant="h6" color="blue-gray">
                        {routes.current.toUpperCase()}
                    </Typography>
                </div>
                <div className="flex items-center justify-between">
                    {/*<IconButton
                        variant="text"
                        color="blue-gray"
                        className="grid xl:hidden"
                        onClick={() => setOpenSidenav(!openSidenav)}
                    >
                        <Bars3Icon strokeWidth={3} className="h-6 w-6 text-blue-gray-500"/>
                    </IconButton>
                     <a href="#" onClick={handleLogout}>
                        <Button
                            variant="text"
                            color="blue-gray"
                            className="hidden items-center gap-1 px-4 xl:flex normal-case"
                        >
                            <PowerIcon className="h-5 w-5 text-blue-gray-500"/>
                            Cerrar Sesión
                        </Button>
                        <IconButton
                            variant="text"
                            color="blue-gray"
                            className="grid xl:hidden"
                        >
                            <PowerIcon className="h-5 w-5 text-blue-gray-500"/>
                        </IconButton>
                    </a>*/}

                    <IconButton variant="text" color="blue-gray" className="xl:hidden" onClick={toggleSidenav}>
                        <Bars3Icon className="h-6 w-6 text-blue-gray-500" />
                    </IconButton>

                    <Menu>
                        <MenuHandler>
                            <div>
                                <Button
                                    variant="text"
                                    color="blue-gray"
                                    className="hidden items-center gap-1 px-4 xl:flex normal-case uppercase"
                                >
                                    <UserCircleIcon className="h-5 w-5 text-blue-gray-500"/>
                                    {userName}
                                </Button>
                                <IconButton
                                    variant="text"
                                    color="blue-gray"
                                    className="grid xl:hidden"
                                >
                                    <UserCircleIcon className="h-5 w-5 text-blue-gray-500"/>
                                </IconButton>
                            </div>
                        </MenuHandler>
                        <MenuList className="w-max border-0">
                            <MenuItem className="flex items-center gap-3" onClick={handleLogout}>
                                <PowerIcon className="h-5 w-5 text-blue-gray-500"/>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="mb-1 font-normal"
                                >
                                    Cerrar sesión
                                </Typography>
                            </MenuItem>
                        </MenuList>
                    </Menu>
                    {/*<IconButton
                        variant="text"
                        color="blue-gray"
                    >
                        <Cog6ToothIcon className="h-5 w-5 text-blue-gray-500"/>
                    </IconButton>*/}
                </div>
            </div>
        </Navbar>
    );
}

export default NavBar;
